<div class="content">
  <h3 class="title">Análisis del Caso</h3>
  <form [formGroup]="form" class="formulario">
    <mat-form-field
      ngDefaultControl
      formControlName="num"
      class="matform"
      appearance="outline"
    >
      <mat-label>Número de Referencia del Reporte</mat-label>
      <input type="text" matInput />
    </mat-form-field>

    <mat-form-field
      ngDefaultControl
      formControlName="observation"
      class="matform"
      appearance="outline"
    >
      <mat-label>Observaciones</mat-label>
      <textarea matInput></textarea>
    </mat-form-field>
  </form>
  <div class="buttons">
    <button mat-raised-button (click)="close()" class="cancel-btn rounded">
      Rechazar Reporte
    </button>
    <button
      mat-raised-button
      [disabled]="!form.valid"
      (click)="closeOk()"
      class="primary-btn rounded"
    >
      Aprobar Reporte
    </button>
  </div>
</div>
